export const navCopy = {
  skip_to_content: "跳转到内容",
  nav_documentation: "文档",
  nav_documentation_short: "文档",
  nav_download: "下载",
  nav_community: "社区",
  nav_tools: "工具",
  nav_search_placeholder: "搜索文档",
  nav_search_aria: "搜索 TypeScript 网站",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_playground: "演练场",
  nav_playground_short: "尝试",
  nav_handbook: "手册",
  nav_this_page_in_your_lang: "当前页面有适用于您语言的翻译版本",
  nav_this_page_in_your_lang_open: "打开",
  nav_this_page_in_your_lang_no_more: "不再询问",
  nav_version_stable_prefix: "已经发布",
  nav_version_between: ", ",
  nav_version_beta_prefix: "目前在 beta 测试中。",
  nav_version_rc_prefix: "可以尝试预发布版本。",
}
